// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.roles {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  flex: 1 1;
  height: 100%;
  box-sizing: border-box;
  overflow: scroll;
}
.roles-title {
  font-size: 1.5em;
  font-weight: bold;
}
.roles-container {
  flex: 1 1;
  margin-top: 2em;
  margin-inline: 2em;
  padding: 2em;
  border-radius: 1em;
  background-color: #fff;
}
.roles-form {
  display: flex;
  flex-direction: column;
}
.roles-form-layout {
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  align-items: flex-start;
  flex-wrap: wrap;
  gap: 0.5em;
}

.roles-access-col {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: space-between;
  flex: 1 1;
}

.roles-check-group {
  display: flex;
  justify-content: flex-start;
  align-items: space-between;
}

.roles-sr-check-group-col .form-check {
  margin: 0 !important;
}
.roles-sr-check-group-col {
  display: grid;
  grid-auto-rows: 1fr 1fr;
  grid-template-columns: 1fr 1fr;
  gap: 0.1em 5em;
}

.roles-sr-check-group-col-header .form-check {
  margin: 0 !important;
}
.roles-sr-check-group-col-header {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-right: 0.5em;
  margin-bottom: 0.5em;
}

.roles-sr-check-group-col-header span,
.roles-sr-check-group-col-header label {
  white-space: nowrap;
}

.roles-access-group-col {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: space-between;
}

.roles-access-label {
  font-weight: bold;
}`, "",{"version":3,"sources":["webpack://./src/components/views/roles/roleForm/roleForm.scss","webpack://./src/sass/globals/mixins.scss","webpack://./src/sass/globals/globals.scss"],"names":[],"mappings":"AAGA;ECFC,aAAA;EACA,uBDEc;ECDd,uBDCsB;EACtB,SAAA;EACA,YAAA;EACA,sBAAA;EACA,gBAAA;AAAD;AAEC;EACC,gBAAA;EACA,iBAAA;AAAF;AAGC;EACC,SAAA;EACA,eAAA;EACA,kBAAA;EACA,YAAA;EACA,kBAAA;EACA,sBEjBM;AFgBR;AAIC;EACC,aAAA;EACA,sBAAA;AAFF;AAIE;ECrBD,aAAA;EACA,sBAAA;EACA,6BDoBsB;ECnBtB,uBDmBoC;EAClC,eAAA;EACA,UAAA;AACH;;AAIA;EC7BC,aAAA;EACA,sBAAA;EACA,2BD4BoB;EC3BpB,0BD2BgC;EAChC,SAAA;AAED;;AACA;ECxCC,aAAA;EACA,2BDwCc;ECvCd,0BDuC0B;AAI3B;;AAAC;EACC,oBAAA;AAGF;AALA;EAIC,aAAA;EACC,uBAAA;EACA,8BAAA;EACA,cAAA;AAIF;;AAAC;EACC,oBAAA;AAGF;AALA;ECtDC,aAAA;EACA,2BDyDc;ECxDd,mBDwD0B;EAC1B,mBAAA;EACA,oBAAA;AAMD;;AAHA;;EAGC,mBAAA;AAKD;;AAFA;EC/DC,aAAA;EACA,sBAAA;EACA,2BD8DoB;EC7DpB,0BD6DgC;AAQjC;;AALA;EACC,iBAAA;AAQD","sourcesContent":["@import '../../../../sass/globals/globals.scss';\n@import '../../../../sass/globals/mixins.scss';\n\n.roles {\n\t@include flex(center, flex-start);\n\tflex: 1;\n\theight: 100%;\n\tbox-sizing: border-box;\n\toverflow: scroll;\n\n\t&-title {\n\t\tfont-size: 1.5em;\n\t\tfont-weight: bold;\n\t}\n\n\t&-container {\n\t\tflex: 1;\n\t\tmargin-top: 2em;\n\t\tmargin-inline: 2em;\n\t\tpadding: 2em;\n\t\tborder-radius: 1em;\n\t\tbackground-color: $white;\n\t}\n\n\t&-form {\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\n\t\t&-layout {\n\t\t\t@include flexColumn(space-evenly, flex-start);\n\t\t\tflex-wrap: wrap;\n\t\t\tgap: .5em;\n\t\t}\n\t}\n}\n\n.roles-access-col {\n\t@include flexColumn(flex-start, space-between);\n\tflex: 1;\n}\n\n.roles-check-group {\n\t@include flex(flex-start, space-between);\n}\n\n.roles-sr-check-group-col {\n\t.form-check {\n\t\tmargin: 0 !important;\n\t}\n\tdisplay: grid; \n  grid-auto-rows: 1fr 1fr; \n  grid-template-columns: 1fr 1fr; \n  gap: .1em 5em; \n}\n\n.roles-sr-check-group-col-header{\n\t.form-check {\n\t\tmargin: 0 !important;\n\t}\n\t@include flex(flex-start, center);\n\tmargin-right: .5em;\n\tmargin-bottom: .5em;\n}\n\n.roles-sr-check-group-col-header span,\n.roles-sr-check-group-col-header label\n{\t\n\twhite-space: nowrap;\n}\n\n.roles-access-group-col {\n\t@include flexColumn(flex-start, space-between);\n}\n\n.roles-access-label {\n\tfont-weight: bold;\n}","@mixin flex($justify-content, $align-items) {\n\tdisplay: flex;\n\tjustify-content: $justify-content;\n\talign-items: $align-items;\n}\n\n@mixin flexColumn($justify-content, $align-items) {\n\tdisplay: flex;\n\tflex-direction: column;\n\tjustify-content: $justify-content;\n\talign-items: $align-items;\n}\n","$dark-red: #8f003c;\n$sidebar-selected-color: #c4145d;\n$sidebar-logo-color: #a53363;\n$logo-color: #920942;\n$white: #fff;\n$grey: #f3f6f9;\n$grey2: #e2e5e7;\n$dark-grey: #777776;\n$font-color: #fff;\n$shadow-color: #4e7da2;\n$font: 'Rubik';\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
